import { useState, useEffect } from "react";
import { WifiSlash } from "@phosphor-icons/react";

export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-banner"
      className="fixed inset-x-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 text-zinc-950 text-sm font-medium py-2 px-4 shadow-lg"
      style={{ top: "calc(env(safe-area-inset-top))" }}
      role="status"
    >
      <WifiSlash size={16} weight="bold" />
      Sem conexão — suas alterações serão sincronizadas quando a internet voltar
    </div>
  );
};
